/**
 * 全局方法注册
 */
import Vue from 'vue'
import {Loading, Message} from 'element-ui'
import md5 from 'js-md5'
import {generateButton, generateName} from '@/utils/i18n'
import {parseTime} from '@/utils/format/date'

Vue.prototype.$md5 = md5
Vue.prototype.getWindowClientWH = getWindowClientWH
Vue.prototype.getImgUrl = getImgUrl
Vue.prototype.showMessage = showMessage
Vue.prototype.showLoading = showLoading
Vue.prototype.formatterOrder = formatterOrder

Vue.prototype.generateName = generateName
Vue.prototype.generateButton = generateButton
Vue.prototype.guid = guid
Vue.prototype.parseTime = parseTime
Vue.prototype.objectGetValue = objectGetValue
Vue.prototype.ellipsis = ellipsis

function getImgUrl(url) {
  return 'api/' + url
}

function showLoading(text, lock, spinner, background) {
  return Loading.service({
    lock: lock || true,
    text: text || '加载中',
    spinner: spinner || 'el-icon-loading',
    background: background || 'rgba(0, 0, 0, 0.7)'
  })
}

function showMessage(message, type) {
  Message({
    message: message,
    type: type
  })
}

/*
 * 获取浏览器高宽
 * @returns {{width: number, height: number}}
 */
function getWindowClientWH() {
  let winWidth = 0
  let winHeight = 0
  // 获取窗口宽度
  if (window.innerWidth) {
    winWidth = window.innerWidth
  } else if ((document.body) && (document.body.clientWidth)) {
    winWidth = document.body.clientWidth
  }
  // 获取窗口高度
  if (window.innerHeight) {
    winHeight = window.innerHeight
  } else if ((document.body) && (document.body.clientHeight)) {
    winHeight = document.body.clientHeight
  }
  // 通过深入Document内部对body进行检测，获取窗口大小
  if (document.documentElement && document.documentElement.clientHeight && document.documentElement.clientWidth) {
    winHeight = document.documentElement.clientHeight
    winWidth = document.documentElement.clientWidth
  }
  return {
    width: winWidth,
    height: winHeight
  }
}

/*
 * 前台获取的排序不是asc和desc,需要转化后转到后台
 * @param order
 * @returns {string}
 */
function formatterOrder(order) {
  let orderBy = 'desc'
  if (order && order.toString().startsWith('asc')) {
    orderBy = 'asc'
  }
  return orderBy
}

/**
 * 获取guid
 */
export function guid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0
    var v = c === 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  })
}

/**
 * 多层嵌套对象取值
 * @param data
 * @param keysString
 * @returns {undefined|*}
 */
function objectGetValue(data, keysString) {
  if (!data) {
    return undefined
  }
  if (!keysString) {
    return data
  }

  // [0],[1]... 属性是数组,只可以一层:obj[0]，不可以多层:obj[0][0]
  let reg = /\[[0-9]+\]/g

  let keys = keysString.split('.')

  for (let key of keys) {
    if (key.match(reg)) {
      // 包含数组
      let ArrKey = key.replace(reg, '')
      let ArrIndex = key.replace(ArrKey, '').replace(/\[/, '').replace(/\]/, '')
      if (data[ArrKey] === undefined) {
        return undefined
      } else if (data[ArrKey][ArrIndex] === undefined) {
        return undefined
      } else {
        data = data[ArrKey][ArrIndex]
      }
    } else {
      // 对象
      if (data[key] === undefined) {
        return undefined
      } else {
        data = data[key]
      }
    }
  }
  return data
}

/**
 * 字符串转json
 * @param jsonString
 * @param defaultValue
 * @returns {{}}
 */
export function parseJson(jsonString, defaultValue) {
  let json = defaultValue || {}
  try {
    json = JSON.parse(jsonString)
  } catch (e) {
    console.log('json转换出错', e)
  }
  return json
}

/**
 * 长字符串格式化
 * @param value
 * @param length
 * @param replaceStr
 * @returns {string|*}
 */
export function ellipsis(value, length = 10, replaceStr = '...') {
  if (!value) return ''
  if (value.length > length) {
    return value.slice(0, length) + replaceStr
  }
  return value
}



// WEBPACK FOOTER //
// ./src/utils/global/function/index.js